import { useContext } from 'react';
import { IModalContext } from './types';
import ModalContext from './ModalContext';

export const useModal = (): IModalContext => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('This component must be a <ModalProvider> component');
  }

  return context;
};
